import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import StandardizedChip from '../../../common/StandardizedChip';

/**
 * VersionHeaderCard Component
 *
 * Displays version header with basic info chips.
 *
 * @param {Object} props
 * @param {Object} props.selectedVersion - Selected version data
 */
function VersionHeaderCard({ selectedVersion }) {
  return (
    <Card
      sx={{
        mb: 2,
        border: '2px solid',
        borderColor: 'primary.light',
        backgroundColor: 'action.hover',
        boxShadow: 3,
      }}
    >
      <CardContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <Typography variant="h6" fontWeight="bold">
              Version {selectedVersion.version_number} Details
            </Typography>
            <StandardizedChip
              label={selectedVersion.provider || 'N/A'}
              color="info"
              variant="outlined"
            />
            <StandardizedChip
              label={selectedVersion.model || 'N/A'}
              color="info"
              variant="outlined"
            />
            <StandardizedChip
              label={
                selectedVersion.version_status?.replace('PromptVersion.', '') ||
                'N/A'
              }
              color={
                selectedVersion.version_status?.includes('ACTIVE')
                  ? 'success'
                  : 'default'
              }
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default VersionHeaderCard;
